import { render } from "./TutorialSessionAdmin.vue?vue&type=template&id=37db240c&ts=true"
import script from "./TutorialSessionAdmin.vue?vue&type=script&lang=ts"
export * from "./TutorialSessionAdmin.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__